import { render, staticRenderFns } from "./_shop.vue?vue&type=template&id=40fd38b1&"
import script from "./_shop.vue?vue&type=script&lang=js&"
export * from "./_shop.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports